// Compact inline-text explanation of WHY each risk chip is lit.
// Extracted from DecisionEnginePage.js during Phase 1 consolidation —
// no logic or visual changes. Purely presentational.
import React from 'react';

export const RiskFactorsStrip = ({ drivers }) => {
  const d = drivers || {};
  const injury = Array.isArray(d.injury) ? d.injury : [];
  const fatigue = Array.isArray(d.fatigue) ? d.fatigue : [];
  const load = Array.isArray(d.load) ? d.load : [];
  if (!injury.length && !fatigue.length && !load.length) return null;

  const Row = ({ label, items, testId, tone }) => {
    if (!items.length) return null;
    const toneCls = {
      injury: 'text-red-700 dark:text-red-300',
      fatigue: 'text-amber-700 dark:text-amber-300',
      load: 'text-indigo-700 dark:text-indigo-300',
    }[tone] || 'text-gray-700 dark:text-gray-300';
    return (
      <span className="inline-flex items-baseline gap-1.5" data-testid={testId}>
        <span className={`text-[11px] font-semibold uppercase tracking-wider ${toneCls}`}>
          {label}
        </span>
        <span className="text-[12px] text-gray-600 dark:text-gray-400">
          {items.join(' · ')}
        </span>
      </span>
    );
  };

  return (
    <div
      className="flex flex-wrap items-baseline gap-x-4 gap-y-1 px-1 pt-1 animate-in fade-in duration-200"
      data-testid="risk-factors-strip"
      aria-label="Risk driver explanations"
    >
      <span className="text-[10px] uppercase tracking-wider text-gray-400 dark:text-gray-500 shrink-0">
        Drivers
      </span>
      <Row label="Injury" items={injury} tone="injury" testId="risk-driver-injury" />
      <Row label="Fatigue" items={fatigue} tone="fatigue" testId="risk-driver-fatigue" />
      <Row label="Load" items={load} tone="load" testId="risk-driver-load" />
    </div>
  );
};
